<template>
  <div class="vx-col w-full mb-base m-auto">
    <vx-card>
      <div class="vx-row mb-4">
        <div class="vx-col sm: w-full md:w-1/2">
          <h2>Manage Users</h2>
        </div>
        <div class="vx-col sm: w-full md:w-1/2 text-right">
          <vs-button class="ml-2 m-auto gradient-btn" @click.prevent="userAddEdit = true"  v-if="!userAddEdit">Add User</vs-button>
        </div>
      </div>
      <div>
        <div
          class="float-left md:w-auto md:mt-0 mb-5 sm:w-full w-full sm:mt-3 mt-3"
          v-if="!userAddEdit"
        >
          <vs-select label="Record Per Page" v-model="perPage" autocomplete>
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item,index) in recordList"
            />
          </vs-select>
        </div>
      </div>
      <div
        class="float-right md:w-auto md:mt-0 mb-5 sm:w-full w-full sm:mt-3 mt-3"
        v-if="!userAddEdit"
      >
        <div class="float-right add-drivers user-btns" v-if="!userAddEdit">
          <vs-button
            type="filled"
            class="mr-1 float-left download-btn gradient-btn"
            icon-pack="feather"
            icon="icon-download"
            title="Sample CSV"
            @click.stop="downloadSampleCSV()"
          ></vs-button>
          <vs-button class="ml-2 m-auto gradient-btn" @click="importUserData()">Import</vs-button>
          <vs-button class="ml-2 m-auto gradient-btn" @click="exportCSV()">Export</vs-button>
        </div>
      </div>
      <form class="w-full" autocomplete="off" v-if="userAddEdit">
        <div class="vx-row mb-2">
          <h4 class="ml-5 mb-5">{{ userIndex ? 'Edit' : 'Add' }} User</h4>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/4 form-group w-full">
            <label class="label">
              First Name
              <span class="text-danger">*</span>
            </label>
            <vs-input
              class="w-full"
              v-validate="'required|alpha_spaces|max:25'"
              name="first_name"
              v-model="firstName"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('first_name') }}</span>
          </div>
          <div class="vx-col md:w-1/4 form-group w-full">
          <label class="label">
              Last Name
              <span class="text-danger">*</span>
            </label>
            <vs-input
              class="w-full"
              v-validate="'required|alpha_spaces|max:25'"
              name="last_name"
              v-model="lastName"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('last_name') }}</span>
          </div>
             <div class="vx-col md:w-1/3">
            <label>Profile</label>
            <div class v-if="!profile_image">
              <vue-image-upload
                field="img"
                @crop-success="cropSuccess"
                v-model="show_image_popup"
                name="profile_image"
                :width="100"
                :height="100"
                lang-type="en"
                img-format="png"
                :no-rotate="false"
                :no-circle="true"
                :no-square="false"
              ></vue-image-upload>
              <vs-button
                class="gradient-btn"
                @click.prevent="show_image_popup = !show_image_popup"
                id="upload-profile-button"
              >Upload Profile</vs-button>
              <span class="text-danger text-sm">{{ errors.first('profile_image') }}</span>
            </div>
            <div class="vx-col md:w-1/2" v-else>
              <div class="img-upload" v-if="profile_image">
                <img
                  :src="profile_image"
                  class="mr-1"
                  style="width: 100px; max-height: 100px; float:left;"
                />
                <vs-button
                  color="primary"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="removeProfile()"
                ></vs-button>
              </div>
            </div>
          </div>
            <div class="vx-col md:w-1/4 form-group w-full mb-4">
            <label class="label">
             Email
              <span class="text-danger">*</span>
            </label>
            <vs-input
              class="w-full"
              v-validate="'required|email'"
              name="email"
              v-model="email"
              autocomplete="off"
              :disabled="userIndex"
            />
            <span class="text-danger text-sm">{{ errors.first('email') }}</span>
          </div>
           <div class="vx-col md:w-1/4 form-group w-full mb-4">
           <label class="label">
             User Role
              <span class="text-danger">*</span>
            </label>
            <vs-select
              class="w-full"
              v-validate="'required'"
              name="role"
              v-model="roleIndex"
              autocomplete
              ref="userRole"
            >
               <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item,index) in roleList"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('role') }}</span>
          </div>
         
          <div class="vx-col md:w-1/4 form-group w-full">
            <vs-input
              class="w-full"
              label="Mobile/Cell"
              v-validate="'numeric|min:10|max:10'"
              name="mobile"
              v-model="mobile"
              autocomplete="off"
              @keydown="filterKey"
              type="number"
            />
            <span class="text-danger text-sm">{{ errors.first('mobile') }}</span>
          </div>
           <div class="vx-col md:w-1/4 form-group w-full">
            <vs-input
              class="w-full"
              label="Phone"
              v-validate="'numeric|min:10|max:10'"
              name="phone"
              v-model="phone"
              autocomplete="off"
              @keydown="filterKey"
              type="number"
            />
            <span class="text-danger text-sm">{{ errors.first('phone') }}</span>
          </div>
        </div>
        <div class="vx-row mb-2">
        
          <!-- <div class="vx-col md:w-1/4 form-group w-full mb-4" v-if="userIndex">
            <vs-input
              class="w-full"
              label="Password"
              name="password"
              v-model="password"
              type="password"
              :disabled="userIndex"
              ref="passwordRef"
            />
          </div> -->
         
          <div class="vx-col md:w-1/4 form-group w-full mb-4">
            <vs-input
              class="w-full"
              label="Position"
              v-validate="'alpha_spaces|max:25'"
              name="designation"
              v-model="designation"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('designation') }}</span>
          </div>
          <div class="vx-col md:w-1/4 form-group w-full mb-4">
            <vs-select
              class="w-full"
              label="Office"
              name="office"
              v-model="office"
              autocomplete
              @change="getDepartment()"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.office_name"
                v-for="(item,index) in officesList"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('office') }}</span>
          </div>
          <div class="vx-col md:w-1/4 form-group w-full mb-4">
            <vs-select
              class="w-full"
              label="Department"
              name="department"
              v-model="department"
              autocomplete
              ref="deptSelect"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.department_name"
                v-for="(item,index) in departmentsList"
              />
            </vs-select>
             <span class="text-danger text-sm">{{ errors.first('department') }}</span>
          </div>
          <div class="vx-col md:w-1/4 form-group w-full mb-4">
            <vs-input
              class="w-full"
              label="User Id"
              v-validate="'alphaNumSchar|max:5'"
              name="user_id"
              v-model="user_id"
            />
            <span class="text-danger text-sm">{{ errors.first('user_id') }}</span>
          </div>
        </div>
        <div class="vx-row mb-4">
          <!-- <div class="vx-col md:w-1/3">
            <label>Profile</label>
            <div class v-if="!profile_image">
              <vue-image-upload
                field="img"
                @crop-success="cropSuccess"
                v-model="show_image_popup"
                name="profile_image"
                :width="100"
                :height="100"
                lang-type="en"
                img-format="png"
                :no-rotate="false"
                :no-circle="true"
                :no-square="false"
              ></vue-image-upload>
              <vs-button
                class="gradient-btn"
                @click.prevent="show_image_popup = !show_image_popup"
                id="upload-profile-button"
              >Upload Profile</vs-button>
              <span class="text-danger text-sm">{{ errors.first('profile_image') }}</span>
            </div>
            <div class="vx-col md:w-1/2" v-else>
              <div class="img-upload" v-if="profile_image">
                <img
                  :src="profile_image"
                  class="mr-1"
                  style="width: 100px; max-height: 100px; float:left;"
                />
                <vs-button
                  color="primary"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="removeProfile()"
                ></vs-button>
              </div>
            </div>
          </div> -->
          <div class="vx-col md:w-1/2" v-if="userIndex">
            <label class="pl-4">QR VCard</label>
            <img :src="qr_code" class="code-border" @click="qrcodePrint(qr_code,'U')" />
            <vs-button
              class="gradient-btn"
              type="filled"
              icon-pack="feather"
              icon="icon-download"
              @click="qrcodePrint(qr_code,'U')"
            >Download</vs-button>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-button
              class="mt-1 m-auto gradient-btn"
              @click.prevent="addUpdateUser()"
              :disabled="button_loading"
              id="user-addupdate"
            >Save</vs-button>
            <vs-button
              class="mt-1 ml-4 m-auto gradient-btn"
              color="primary"
              @click.prevent="cancelAddEdit()"
            >Cancel</vs-button>
          </div>
        </div>
      </form>
      <div class="mt-5 mb-5">
        <vs-table :data="users" pagination :max-items="perPage">
          <template slot="thead">
            <vs-th sort-key="firstName">First Name</vs-th>
            <vs-th sort-key="lastName">Last Name</vs-th>
            <vs-th sort-key="email">Email</vs-th>
            <vs-th sort-key="phone">Phone</vs-th>
            <vs-th sort-key="userType">Role</vs-th>
            <vs-th sort-key="designation">position</vs-th>
            <vs-th style="width: 10%;">Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ tr.firstname | capitalize }}</vs-td>
              <vs-td>{{ tr.lastname | capitalize }}</vs-td>
              <vs-td>{{ tr.email }}</vs-td>
              <vs-td>{{ tr.phone }}</vs-td>
              <vs-td>
                <span v-if="tr.is_manager">Manager</span>
                <span v-else-if="tr.roles === 'SA'">Super Admin</span>
                <span v-else-if="tr.roles === 'CA'">Company Admin</span>
                <span v-else-if="tr.roles === 'HR'">HR Manager</span>
                <span v-else>User</span>
                <!-- <span v-show="tr.roles === 'SA'">Super Admin</span>
                <span v-show="tr.roles === 'CA'">Organization Admin</span>
                <span v-show="tr.roles === 'HR'">HR Manager</span>
                <span v-show="tr.roles === 'U'">Users</span>-->
              </vs-td>
              <vs-td>{{ tr.designation | shortName(30)}}</vs-td>
              <vs-td>
                <vs-button
                  color="#4285F4"
                  type="filled"
                  class="mr-2 mb-2 float-left"
                  icon-pack="feather"
                  icon="icon-eye"
                  size="small"
                  title="View User Details"
                  @click.stop="viewUserDeatils(tr.id)"
                ></vs-button>
                <vs-button
                  color="#F4B400"
                  type="filled"
                  class="mr-2 mb-2 float-left"
                  icon-pack="feather"
                  icon="icon-edit-2"
                  size="small"
                  title="Edit User"
                  @click.stop="editUser(data[indextr])"
                ></vs-button>
                <vs-button
                  color="#DB4437"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  size="small"
                  title="Delete User"
                  @click.stop="confirmDelete(data[indextr].id)"
                ></vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
    <vs-popup class="holamundo" title="Import User Details" :active.sync="importUserPopup">
      <form class="w-full" autocomplete="off" data-vv-scope="import-form">
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/1 form-group w-full mb-5">
            <select
              class="new_select con-select w-full vs-select--label"
              name="importOffice"
              placeholder="Office"
              v-model="importOffice"
              v-validate="'required'"
              @change="getDepartment()"
            >
              <option :value="null" disabled hidden>Office</option>
              <option
                v-for="(o,index) in officesList"
                :key="index"
                :value="o.id"
              >{{ o.office_name }}</option>
            </select>
            <span
              v-show="errors.has('import-form.importOffice')"
              class="text-danger text-sm"
            >{{ errors.first('import-form.importOffice') }}</span>
          </div>
          <div class="vx-col md:w-1/1 form-group w-full mb-5" v-show="importOffice != null">
            <select
              class="new_select con-select w-full vs-select--label"
              name="importDepartment"
              placeholder="Department"
              v-model="importDepartment"
              v-validate="departmentsList.length?'required':''"
            >
              <option :value="null" disabled hidden>Department</option>
              <option
                v-for="(d,index) in departmentsList"
                :key="index"
                :value="d.id"
              >{{ d.department_name }}</option>
            </select>
            <span
              v-show="errors.has('import-form.importDepartment')"
              class="text-danger text-sm"
            >{{ errors.first('import-form.importDepartment') }}</span>
          </div>
          <div class="vx-col md:w-1/1 form-group w-full">
            <input
              type="file"
              id="file"
              name="importFile"
              class="vs-inputx vs-input--input normal hasValue"
              accept=".csv"
              v-validate="'required'"
              ref="file"
              v-on:change="handleFileUpload()"
            />
            <!-- <vs-input
              class="w-full"
              type="file"
              label="Import file"
              v-validate="'required'"
              name="importFile"
              v-model="importFile"
              autocomplete="off"
              v-on:change="handleFileUpload()"
              ref="file"
            />-->
            <span
              v-show="errors.has('import-form.importFile')"
              class="text-danger text-sm"
            >{{ errors.first('import-form.importFile') }}</span>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-button
              class="mt-5 m-auto"
              @click.prevent="importUser()"
              :disabled="button_loading"
              id="import"
            >Import</vs-button>
          </div>
        </div>
      </form>
    </vs-popup>
    <vs-popup class="holamundo" title="User Details" :active.sync="userDetailPopup">
      <div class="overflow-auto mb-5">
        <table class="application-detail" v-if="userViewData">
          <!-- <caption><h4><strong>Personal Information</strong></h4></caption> -->
          <tr>
            <th>First Name</th>
            <td>{{ userViewData.firstname | capitalize }}</td>
          </tr>
          <tr>
            <th>Last Name</th>
            <td>{{ userViewData.lastname | capitalize }}</td>
          </tr>
          <tr>
            <th>Email</th>
            <td>{{ userViewData.email ? 'Yes' : 'NO' }}</td>
          </tr>
          <tr>
            <th>Role</th>
            <td>
              <span v-if="userViewData.is_manager">Manager</span>
              <span v-else-if="userViewData.roles === 'SA'">Super Admin</span>
              <span v-else-if="userViewData.roles === 'CA'">Company Admin</span>
              <span v-else-if="userViewData.roles === 'HR'">HR Manager</span>
              <span v-else>User</span>
            </td>
          </tr>
          <tr>
            <th>Phone</th>
            <td>{{ userViewData.phone }}</td>
          </tr>
          <tr>
            <th>Designation</th>
            <td>{{ userViewData.designation }}</td>
          </tr>
          <tr v-if="userViewData.office">
            <th>Office</th>
            <td>{{ userViewData.office.office_name }}</td>
          </tr>
          <tr v-if="userViewData.department">
            <th>Department</th>
            <td>{{ userViewData.department.department_name }}</td>
          </tr>
          <tr v-if="userViewData.qr_code">
            <th>QR Code</th>
            <td>
              <!-- <vs-button
                  color="#0057FF"
                  type="filled"
                  class="mr-2 mt-10 float-left"
                  icon-pack="feather"
                  icon="icon-download-cloud"
                  size="small"
                  title="Download Qr-code"
                  @click.stop="downloadQrcode(userViewData.qr_code)"
              ></vs-button>-->
              <img
                :src="userViewData.qr_code"
                class="code-border"
                alt
                @click="qrcodePrint(userViewData.qr_code,'U')"
              />
            </td>
          </tr>
        </table>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import VueImageUpload from "vue-image-crop-upload";
Validator.extend("verify_password", {
  //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
  validate: value => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  }
});

Validator.extend("verify_password", {
  //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
  validate: value => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  }
});

//Validator.updateDictionary(dictionary);

const dict = {
  custom: {
    first_name: {
      required: "Please enter first name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "First name should not be greater than 25 characters"
    },
    last_name: {
      required: "Please enter last name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Last name should not be greater than 25 characters"
    },
    email: {
      required: "Please enter email",
      email: "Please enter valid email"
    },
    phone: {
      required: "Please enter phone number ",
      numeric: "Please enter valid number",
      min: "Phone number must be at least 10 digits",
      max: "Phone number should not be greater than 10 digits"
    },
    mobile: {
      required: "Please enter mobile number ",
      numeric: "Please enter valid number",
      min: "Mobile/Cell number must be at least 10 digits",
      max: "Mobile/Cell number should not be greater than 10 digits"
    },
    password: {
      required: "Please enter password",
      min: "Password should be minimum 8 characters",
      verify_password:
        "Password should be minimum 8 characters : 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)"
    },
    password_confirmation: {
      required: "Please enter confirm password",
      confirmed: "Password and confirm password should be same"
    },
    role: {
      required: "Please select user role"
    },
    office: {
      required: "Please select office"
    },
    department: {
      required: "Please select department"
    },
    designation: {
      required: "Please enter user designation",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Designation should not be greater than 25 characters"
    },
    user_id: {
      required: "Please enter user id",
      alpha_num: "Only alphabetic characters and numbers allowed",
      max: "User Id should not be greater than 5 characters",
      alphaNumSchar: "Only alphanumeric and special characters allowed"
    },
    importDepartment:{
      required:"Please select department",
    },
    importOffice:{
      required:"Please select office",
    },
    importFile:{
      required:"Please select file",
    },
  }
};
// register custom messages
Validator.localize("en", dict);

export default {
  components: {
    "vue-image-upload": VueImageUpload
  },
  data() {
    return {
      user_id: null,
      perPage: 10,
      users: [],
      deleteIndex: 0,
      userAddEdit: false,
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      mobile: null,
      password: null,
      confirm_password: null,
      userIndex: null,
      roleIndex: 'U',
      office: null,
      department: null,
      designation: null,
      roleList: [],
      officesList: [],
      departmentsList: [],
      userDetailPopup: false,
      importUserPopup: false,
      importFile: null,
      importOffice: null,
      importDepartment: null,
      userViewData: [],
      profile_image: null,
      show_image_popup: false,
      profile_image_update: false,
      qr_code: ""
    };
  },
  created() {
    console.log("role ",this.$store.state.uInfo.role)
    if (
      this.$store.state.uInfo.role !== "CA" &&
      this.$store.state.uInfo.role !== "HR"
    ) {
      history.back();
    }

    if (this.$store.state.uInfo.role === "CA") {
      this.roleList.push(
        {
          text: "Company Admin",
          value: "CA"
        },
        {
          text: "Manager",
          value: "M"
        },
        {
          text: "HR Manager",
          value: "HR"
        },
        {
          text: "User",
          value: "U"
        }
      );
    }

    if (this.$store.state.uInfo.role === "HR") {
      this.roleList.push({
        text: "User",
        value: "U"
      });
    }
    //   VeeValidate.Validator.extend('verify_password', {
    //   //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
    //   validate: value => {
    //       var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    //       return strongRegex.test(value);
    //   }
    //  });
  },
  watch:{
    importUserPopup(val){
      if(!val){
        document.getElementById("file").value = "";
        this.importFile = null;
        this.importDepartment = null;
        this.importOffice = null;
           this.$validator.reset("import-form");
        this.errors.clear("import-form");
      }
    }
  },
  mounted() {
    this.getusers();
    this.getOffice();
    // this.getDepartment();
  },
  computed: {
    email_validate() {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.email);
    }
  },
  methods: {
    removeProfile() {
      this.profile_image = "";
      this.profile_image_update = false;
      if (this.userIndex) {
        this.profile_image_update = true;
      }
    },
    cropSuccess(imgDataUrl, field) {
      if (this.userIndex) {
        this.profile_image_update = true;
      }
      this.profile_image = imgDataUrl;
      this.profile_image_update = true;
      // if(this.$route.params.id) {
      //     this.imageUpdate = true
      // }
    },
    // ===== View User Details =====
    viewUserDeatils(id) {
      let url = "user/getOneUser?id=" + id;
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          this.userViewData = response.data.data;

          this.userDetailPopup = true;
        })
        .catch(e => {
          this.showError(e);
        });
      //this.$router.push("/drivers/view/" + id);
    },
    importUserData() {
      this.importUserPopup = true;
    },
    handleFileUpload() {
      this.importFile = this.$refs.file.files[0];
      console.log("import file", this.importFile);
    },
    importUser() {
      this.$validator.validateAll("import-form").then(result => {
        if (result) {
          this.button_loader(true, "#import");
          let formData = new FormData();
          formData.append("file", this.importFile);
          formData.append("department", this.importDepartment=='null'?null:this.importDepartment);
          formData.append("office", this.importOffice);
          console.log("gdrger",this.importDepartment);
          this.axios
            .post("user/importUser", formData, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
            .then(response => {
              this.button_loader(false, "#import");
              this.$validator.reset("import-form");
              this.errors.clear("import-form");
              document.getElementById("file").value = "";
              this.importFile = null;
              this.importDepartment = null;
              this.importOffice = null;
              this.importUserPopup = false;
              let text = "CSV import successfully!!!";
              this.$vs.notify({
                text: text,
                color: "success",
                position: "top-right"
              });
              this.getusers();
            })
            .catch(e => {
              //this.button_loader(false, "#import");
              this.showError(e, "#import");
            });
        }
      });
    },
    // ===== Download QR-Code =====
    downloadQrcode(data) {
      let myCanvas = data;
      let type = "image/png";
      //.attr("download", "img.png")
      let image = myCanvas.replace(type, "image/octet-stream");
      window.location.href = image;
    },
    // ===== Download Sample User CSV  =====
    downloadSampleCSV() {
      let url = "user/exportPreDefineTemplate";
      this.axios
        .get(url)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Sample-CSV.csv");
          document.body.appendChild(link);
          link.click();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    // ===== Get User List =====
    getusers() {
      this.$vs.loading({ color: "primary" });

      let url = "user/getOrganizationalUser";
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.users = data;
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    // ===== Get Office List =====
    getOffice() {
      this.$vs.loading({ color: "primary" });

      let url = "office/getAll";
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.officesList = data;
          if(!this.user_id){
            let defaultOffice = this.officesList.filter((i) => i.isDefault == true);
            this.office = defaultOffice[0].id;
            this.getDepartment();
          }
        })
        .catch(e => {
          this.showError(e);
        });
    },
    // ===== Get Department List from Office =====
    getDepartment() {
      let office = null;
      if (this.office) {
        office = this.office;
        if (this.$refs.deptSelect) {
          this.$refs.deptSelect.valuex = null;
          this.$refs.deptSelect.clear = true;
          this.department = null;
        }
      }
      if (this.importOffice) {
        office = this.importOffice;
        this.importDepartment = null;
      }
      if (office) {
        this.$vs.loading({ color: "primary" });

        let url = "dept/getAll?office_id=" + office;
        this.axios
          .get(url)
          .then(response => {
            this.$vs.loading.close();
            let data = response.data.data;
            this.departmentsList = data;
          })
          .catch(e => {
            this.showError(e);
          });
      }
    },
    // ===== Export User CSV =====
    exportCSV() {
      let url = "user/getOrganizationalUser?export=export";
      this.axios
        .get(url)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "UserDeatils.csv");
          document.body.appendChild(link);
          link.click();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    // ===== Confirm Delete =====
    confirmDelete(index) {
      this.deleteIndex = index;
      // jquery call
      let text =
        "Deleting a user will remove all the data related to user and once deleted, it can not be reverted.   Are you sure you want to delete this User?";

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: text,
        acceptText: "Delete",
        accept: this.deleteUser
      });
    },
    // ===== Delete User =====
    deleteUser() {
      let input = {
        data: {
          id: this.deleteIndex
        }
      };
      this.$vs.loading({ color: "primary" });
      this.axios
        .delete("user/deleteUser", input)
        .then(response => {
          this.$vs.loading.close();
          let text = "User deleted successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.deleteIndex = 0;
          this.getusers();
        })
        .catch(e => {
          this.deleteIndex = 0;
          this.showError(e);
        });
    },
    // ===== Edit User =====
    editUser(user) {
      this.userAddEdit = true;
      this.user_id = user.user_id;
      this.qr_code = user.qr_code;
      this.profile_image = user.profile_image;
      this.userIndex = user.id;
      this.firstName = user.firstname;
      this.lastName = user.lastname;
      this.email = user.email;
      this.password = "######";
      this.roleIndex = user.is_manager ? "M" : user.roles;
      this.phone = user.phone;
      this.mobile = user.mobile;
      this.designation = user.designation;
      if (user.office) {
        this.office = user.office.id;
      } else {
        this.office = null;
      }
      this.getDepartment();
      if (user.department) {
        this.department = user.department.id;
      } else {
        this.department = null;
      }

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    // ===== Add / Upadte User Validation =====
    addUpdateUser() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.button_loader(true, "#user-addupdate");

          if (this.userIndex) {
            this.updateUser();
          } else {
            this.addUser();
          }
        }
      });
    },
    // ===== Add User =====
    addUser() {
      let input = {
        user_id: this.user_id,
        firstname: this.firstName,
        lastname: this.lastName,
        email: this.email,
        mobile: this.mobile,
        phone: this.phone,
        password: this.password,
        confirmpassword: this.confirm_password,
        is_manager: this.roleIndex == "M" ? true : false,
        type: this.roleIndex == "M" ? "HR" : this.roleIndex,
        designation: this.designation,
        office: this.office,
        department: this.department,
        profile_image: this.profile_image,
        profile_image_update: this.profile_image_update
      };
      this.axios
        .post("user/createUser", input)
        .then(response => {
          this.button_loader(false, "#user-addupdate");
          let text = "User created successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.user_id = null;
          this.userAddEdit = false;
          this.userIndex = null;
          this.firstName = null;
          this.lastName = null;
          this.email = null;
          this.phone = null;
          this.mobile = null;
          this.password = null;
          this.roleIndex = 'U';
          this.designation = null;
          this.department = null; 
          let defaultOffice = this.officesList.filter((i) => i.isDefault == true);
          this.office = defaultOffice[0].id;
          this.getDepartment();
          this.profile_image = null;
          this.profile_image_update = false;
          this.show_image_popup = false;
          this.getusers();
        })
        .catch(e => {
          this.showError(e, "#user-addupdate");
        });
    },
    // ===== Update User =====
    updateUser() {
      let input = {
        user_id: this.user_id,
        id: this.userIndex,
        firstname: this.firstName,
        lastname: this.lastName,
        phone: this.phone,
        mobile: this.mobile,
        is_manager: this.roleIndex == "M" ? true : false,
        type: this.roleIndex == "M" ? "HR" : this.roleIndex,
        designation: this.designation,
        office: this.office,
        department: this.department,
        profile_image: this.profile_image,
        profile_image_update: this.profile_image_update
      };
      console.log(input);
      this.axios
        .put("user/editUser", input)
        .then(response => {
          this.button_loader(false, "#country-addupdate");
          let text = "User updated successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
        this.cancelAddEdit();
          this.getusers();
        })
        .catch(e => {
          this.showError(e, "#country-addupdate");
        });
    },
    // ===== Cancel User Details =====
    cancelAddEdit() {
      this.userAddEdit = false;
      this.userIndex = null;
      this.firstName = null;
      this.user_id = null;

      this.lastName = null;
      this.email = null;
      this.phone = null;
      this.mobile = null;
      this.password = null;
      this.confirm_password = null;
      this.roleIndex = 'U';
      this.designation = null;
      this.office = null;
      this.department = null;
      this.profile_image = null;
      this.profile_image_update = false;
      let defaultOffice = this.officesList.filter((i) => i.isDefault == true);
      this.office = defaultOffice[0].id;
      this.getDepartment();
      this.show_image_popup = false;
    }
  }
};
</script>
<style>
table.application-detail {
  border-collapse: collapse;
  width: 100%;
}

table.application-detail th,
table.application-detail td {
  text-align: left;
  padding: 15px;
}

table.application-detail th {
  background-color: #f8f8f8;
  color: #6b6661;
  width: 25%;
}
button.vs-button:hover .vs-button-text {
  color: #f8f8f8;
}
.new_select {
  background: #fff !important;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  height: 43.59px !important;
  border-radius: 5px !important;
  padding: 0.7rem;
  font-size: 1rem;
}

@media only screen and (min-width: 1199px) and (max-width: 1341px) {
  .download-btn {
    height: 35px !important;
    width: 40px !important;
  }
  .download-btn .vs-icon {
    top: 0 !important;
  }
}

@media only screen and (max-width: 881px) and (min-width: 768px) {
  .download-btn {
    height: 35px !important;
    width: 40px !important;
  }
  .download-btn .vs-icon {
    top: 0 !important;
  }
}
h2 {
  color: #000;
  font-weight: 600;
  font-size: 20px;
}
.img-upload img {
  object-fit: cover;
  border-radius: 50%;
}
</style>